/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TabContainer } from '@marriott/mi-common-static-components';
import { TabContainerProps } from './RnBTabContainer.types';
import { StyledTabContainer } from './RnBTabContainer.styles';

interface ModelObject {
  [element: string]: any;
}

export const RnBTabContainer: FC<TabContainerProps> = props => {
  const tabWidth = `${100 / props?.model?.tabDetails?.length}%`;
  const [updatedModelProps, setUpdatedModelProps] = useState<TabContainerProps>();

  useEffect(() => {
    if (props?.model?.cqItems) {
      let updatedProps = props;

      Object.keys(props?.model?.cqItems)?.forEach((key: any) => {
        if (
          props?.model?.cqItems?.[key]?.[':itemsOrder']?.length &&
          props?.model?.cqItems?.[key]?.[':itemsOrder']?.length > 0
        ) {
          const items: ModelObject = {};
          props?.model?.cqItems?.[key]?.[':itemsOrder'].forEach((element: string) => {
            Object.keys(props?.model?.cqItems?.[key]?.[':items']).forEach(item => {
              if (item === element) {
                items[element] = props?.model?.cqItems?.[key]?.[':items']?.[element];
              }
            });
          });
          updatedProps = {
            ...updatedProps,
            model: {
              ...updatedProps?.model,
              cqItems: {
                ...updatedProps?.model?.cqItems,
                [key]: { ...updatedProps?.model?.cqItems?.[key], ':items': items },
              },
            },
          };
        }
      });

      setUpdatedModelProps(updatedProps);
    }
  }, []);

  return updatedModelProps ? (
    <StyledTabContainer data-testid="rnb-TabContainer" data-component-name="o-rnb-TabContainer" tabWidth={tabWidth}>
      <TabContainer
        {...updatedModelProps}
        key="data from model"
        model={updatedModelProps?.model}
        isAuthorMode={updatedModelProps?.model?.isAuthor}
        flexibleTabWidth={updatedModelProps?.model?.flexibleTabWidth}
        allowedComponents={updatedModelProps?.allowedComponents}
        tabsPerViewInDesktop={updatedModelProps?.model?.tabDetails?.length}
      />
    </StyledTabContainer>
  ) : null;
};

export const TabContainerConfig = {
  emptyLabel: 'TabContainer',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/tabcontainer`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabEditableComponent = (props: any) => {
  return (
    <EditableComponent config={TabContainerConfig} {...props}>
      <RnBTabContainer {...props} />
    </EditableComponent>
  );
};
